import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import calendarVglIcon from '../../../assets/images/Calendar-VGL-icon.png';
import {
  Grid,
  Typography,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import PropTypes from 'prop-types';

import useStyles from '../Main.style';

const WelcomeModal = ({ userDetails }) => {
  const classes = useStyles();
  const [openWelcomeDialog, setOpenWelcomeDialog] = useState(null);

  useEffect(() => {
    if (!Cookies.get('welcomeLoaded')) {
      Cookies.set('welcomeLoaded', true);
      setOpenWelcomeDialog(true);
    }
  }, []);

  const handleClose = () => {
    setOpenWelcomeDialog(false);
  };

  return (
    <Dialog
      className={classes.dialogOuterMedium}
      open={openWelcomeDialog}
      onClose={handleClose}
      aria-labelledby="responsive-dialog-title"
    >
      <Box className={classes.innercontentWhite}>
        <Box className={classes.innercontent} p={2}>
          <Box className={classes.innercontentWhite}>
            <DialogTitle
              className={classes.dialogTitle}
              id="responsive-dialog-title"
              style={{ padding: '0' }}
            >
              <Typography variant="h2">Welcome!</Typography>
              <IconButton aria-label="close" onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent style={{ padding: '0' }}>
              <Grid container>
                <Grid item xs={12}>
                  <Box mt={0.5} />
                  <Typography variant="body2">
                    {`Hello, `}
                    {userDetails?.firstName
                      ? userDetails?.firstName.split('')[0].toUpperCase() +
                        userDetails?.firstName.substring(1, `${userDetails?.firstName?.length}  `)
                      : ''}
                    {` - `}
                    <br />
                    <br />
                    Welcome to the Vector Performance Portal.
                    <br />
                    <br />
                    Here you’ll find a wide range of tools and resources tailored to your needs,
                    allowing you to set goals, track progress, and collaborate with your team. This
                    portal is dedicated to fostering a culture of growth, recognition, and
                    collective success among our global team. And, of course, it is key to
                    demonstrating our results-only mindset.
                    <br />
                    <br />
                    We look forward to seeing your accomplishments and helping you reach your
                    personal and professional goals.
                    <br />
                    <br />
                    And we are grateful for your valuable contribution to the team. It just wouldn’t
                    be the same without you!
                    <br />
                    <br />
                    <br />
                    #LogisticsWithPurpose
                    <br />
                    <br />
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Box className={classes.modalfooterlogo}>
                    <Box mr={1} display="flex">
                      <img
                        className={classes.img}
                        src={calendarVglIcon}
                        alt="Vector"
                        style={{ width: '18px' }}
                      />
                    </Box>
                    <Box>
                      <Typography variant="body2">Vector Global Logistics</Typography>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </DialogContent>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

// PropTypes validation
WelcomeModal.propTypes = {
  userDetails: PropTypes.shape({
    firstName: PropTypes.string,
  }),
};

// Default props
WelcomeModal.defaultProps = {
  userDetails: {
    firstName: '',
  },
};

export default WelcomeModal;
